import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { clearConsent, readConsent } from "@/lib/consent";

const SECTIONS: Array<{ title: string; body: string }> = [
  {
    title: "Quién trata tus datos",
    body: "VIVI con Amor y Arte (Panamá) es responsable de los datos que se recogen en este sitio. El canal de contacto para cualquier consulta es el WhatsApp +507 61568575.",
  },
  {
    title: "Qué datos tratamos",
    body: "Los que escribís en los formularios (nombre, empresa o consultorio, correo, teléfono, producto de interés y logo), los de tu pedido y los de tu cuenta si la creás. Además, si aceptás, datos de navegación: páginas vistas, clics, identificadores de cookies y grabaciones de sesión sin contenido de formularios.",
  },
  {
    title: "Para qué los usamos",
    body: "Responder tu cotización y coordinar tu pedido; procesar compras y entregas; entender qué páginas sirven y cuáles no; y, solo con tu permiso de publicidad, mostrarte nuestros productos en Instagram y Facebook.",
  },
  {
    title: "Herramientas de terceros",
    body: "Google Analytics 4 y Microsoft Clarity (medición) y Meta Pixel (publicidad). Google Tag Manager solo administra esas etiquetas y no se activa sin tu consentimiento. Cada herramienta recibe identificadores técnicos y datos de uso, no el contenido de tus formularios.",
  },
  {
    title: "Base legal y consentimiento",
    body: "Tratamos datos de navegación con tu consentimiento previo, informado y revocable, conforme a la Ley 81 de 2019 de Protección de Datos Personales. Los datos de tu pedido se tratan para ejecutar la relación comercial que pediste.",
  },
  {
    title: "Cuánto tiempo los guardamos",
    body: "Los datos de navegación, mientras tu consentimiento esté vigente o hasta que lo retires. Los datos de pedidos y facturación, durante el plazo que exija la normativa fiscal y contable aplicable.",
  },
  {
    title: "Tus derechos",
    body: "Podés pedir acceso, rectificación, cancelación u oposición sobre tus datos, y retirar el consentimiento en cualquier momento sin que eso afecte pedidos ya realizados. Escribinos por WhatsApp y lo gestionamos. También podés acudir a la Autoridad Nacional de Transparencia y Acceso a la Información (ANTAI).",
  },
];

const Privacy = () => {
  const [summary, setSummary] = useState("Sin decisión guardada.");

  useEffect(() => {
    const consent = readConsent();
    if (!consent) return;
    setSummary(
      `Medición: ${consent.analytics ? "activada" : "desactivada"} · Publicidad: ${consent.marketing ? "activada" : "desactivada"}.`,
    );
  }, []);

  return (
    <div className="container mx-auto max-w-3xl px-4 py-16">
      <h1 className="font-playfair text-3xl font-bold text-brown-dark md:text-4xl">
        Política de Privacidad
      </h1>
      <p className="mt-2 text-sm text-brown-light/80">
        Última actualización: octubre de 2026.
      </p>

      <div className="mt-8 space-y-6">
        {SECTIONS.map((section) => (
          <section key={section.title}>
            <h2 className="font-playfair text-xl font-semibold text-brown-dark">
              {section.title}
            </h2>
            <p className="mt-2 leading-relaxed text-brown-light/90">
              {section.body}
            </p>
          </section>
        ))}
      </div>

      <div className="mt-10 rounded-2xl border border-primary/20 bg-background p-6">
        <h2 className="font-playfair text-xl font-semibold text-brown-dark">
          Tu decisión actual
        </h2>
        <p className="mt-2 text-sm text-brown-light/90">{summary}</p>
        <p className="mt-2 text-sm text-brown-light/90">
          Podés cambiarla cuando quieras: al retirarla se borran las cookies de
          medición y atribución y el aviso vuelve a aparecer.
        </p>
        <Button
          variant="outline"
          className="mt-4 rounded-full"
          onClick={clearConsent}
        >
          Cambiar mi decisión
        </Button>
      </div>

      <p className="mt-8 text-sm text-brown-light/80">
        ¿Dudas sobre un pedido?{" "}
        <Link
          to="/contact"
          className="text-primary-dark underline underline-offset-4 hover:text-brown"
        >
          Escribinos
        </Link>
        .
      </p>
    </div>
  );
};

export default Privacy;
